import { db } from "../../shared/config";
import {
    collection,
    addDoc,
    getDocs,
    getDoc,
    doc,
    updateDoc,
    deleteDoc,
    query,
    orderBy,
    startAfter,
    endBefore,
    limitToLast,
    limit,
    Timestamp,
    where,
} from "firebase/firestore";
import {
    GET_BAGDONATIONS,
    ADD_BAGDONATION,
    GET_BAGDONATION,
    RESET_BAGDONATION,
    BAGDONATIONS_ERROR,
} from "../types/bagdonation_type";

import { setAlert } from "./alert";
import { LIMIT } from "../../domain/constant";
//GET BAGDONATIONS
const bagdonationsRef = collection(db, "bagdonations");
export const getbagdonations =
    ({ term, termField, orderValue = "createdAt", orderType = "desc" }) =>
        async (dispatch) => {
            try {
                let searchQuery = null;
                if (term) {
                    searchQuery = query(bagdonationsRef, where(termField, "==", term));
                } else {
                    searchQuery = query(
                        bagdonationsRef,
                        orderBy(orderValue, orderType),
                        limit(LIMIT)
                    );
                }
                const querySnapshot = await getDocs(searchQuery);
                const data = [];
                querySnapshot.forEach((doc) => {
                    data.push({ id: doc.id, ...doc.data() });
                });
                dispatch({
                    type: GET_BAGDONATIONS,
                    payload: data,
                });
            } catch (err) {
                console.log(err);
                dispatch(setAlert("Something went wrong", "danger"));
                dispatch({
                    type: BAGDONATIONS_ERROR,
                });
            }
        };

export const getNextbagdonations =
    ({ term, termField, last, orderValue = "createdAt", orderType = "desc" }) =>
        async (dispatch) => {
            try {
                let searchQuery = null;
                if (term) {
                    searchQuery = query(
                        bagdonationsRef,
                        orderBy(orderValue, orderType),
                        startAfter(last[orderValue]),
                        limit(LIMIT),
                        where(termField, "==", term)
                    );
                } else {
                    searchQuery = query(
                        bagdonationsRef,
                        orderBy(orderValue, orderType),
                        startAfter(last[orderValue]),
                        limit(LIMIT)
                    );
                }
                const querySnapshot = await getDocs(searchQuery);
                const data = [];
                querySnapshot.forEach((doc) => {
                    data.push({ id: doc.id, ...doc.data() });
                });
                dispatch({
                    type: GET_BAGDONATIONS,
                    payload: data,
                });
            } catch (err) {
                console.log(err);
                dispatch(setAlert("Something went wrong", "danger"));
                dispatch({
                    type: BAGDONATIONS_ERROR,
                });
            }
        };
export const getPreviousbagdonations =
    ({ term, termField, first, orderValue = "createdAt", orderType = "desc" }) =>
        async (dispatch) => {
            try {
                let searchQuery = null;
                if (term) {
                    searchQuery = query(
                        bagdonationsRef,
                        orderBy(orderValue, orderType),
                        endBefore(first[orderValue]),
                        limitToLast(LIMIT),
                        where(termField, "==", term)
                    );
                } else {
                    searchQuery = query(
                        bagdonationsRef,
                        orderBy(orderValue, orderType),
                        endBefore(first[orderValue]),
                        limitToLast(LIMIT)
                    );
                }

                const querySnapshot = await getDocs(searchQuery);
                const data = [];
                querySnapshot.forEach((doc) => {
                    data.push({ id: doc.id, ...doc.data() });
                });
                dispatch({
                    type: GET_BAGDONATIONS,
                    payload: data,
                });
            } catch (err) {
                console.log(err);
                dispatch(setAlert("Something went wrong", "danger"));
                dispatch({
                    type: BAGDONATIONS_ERROR,
                });
            }
        };

export const addbagdonation = (data) => async (dispatch) => {
    try {
        data.createdAt = Timestamp.fromDate(new Date());
        const docRef = await addDoc(bagdonationsRef, data);
        dispatch({
            type: ADD_BAGDONATION,
        });
        dispatch(setAlert("donation added successfully", "success"));
    } catch (e) {
        console.error("Error adding document: ", e);
        dispatch(setAlert("Something went wrong", "danger"));
        dispatch({
            type: BAGDONATIONS_ERROR,
        });
    }
};

export const getbagdonation = (id) => async (dispatch) => {
    try {
        dispatch({
            type: RESET_BAGDONATION,
        });
        const docRef = doc(db, "bagdonations", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            data.id = id;
            dispatch({
                type: GET_BAGDONATION,
                payload: data,
            });
        } else {
            dispatch(setAlert("Something went wrong", "danger"));
            dispatch({
                type: BAGDONATIONS_ERROR,
            });
        }
    } catch (err) {
        dispatch(setAlert("Something went wrong", "danger"));
        dispatch({
            type: BAGDONATIONS_ERROR,
        });
    }
};
export const editbagdonation = (id, data) => async (dispatch) => {
    try {
        const docSnap = await updateDoc(doc(db, "bagdonations", id), data);
        dispatch(setAlert("bagdonation updated successfully", "success"));
    } catch (err) {
        dispatch(setAlert("Something went wrong", "danger"));
        dispatch({
            type: BAGDONATIONS_ERROR,
        });
    }
};

export const deletebagdonation = (id) => async (dispatch) => {
    try {
        const docSnap = await deleteDoc(doc(db, "bagdonations", id));
        dispatch(setAlert("bagdonation deleted successfully", "success"));
    } catch (err) {
        dispatch(setAlert("Something went wrong", "danger"));
        dispatch({
            type: BAGDONATIONS_ERROR,
        });
    }
};
